import { render, staticRenderFns } from "./UchartsRing.vue?vue&type=template&id=0ec8c124&scoped=true"
import script from "./UchartsRing.vue?vue&type=script&lang=js"
export * from "./UchartsRing.vue?vue&type=script&lang=js"
import style0 from "./UchartsRing.vue?vue&type=style&index=0&id=0ec8c124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8c124",
  null
  
)

export default component.exports